import { useTranslation } from "react-i18next";

export const PASS_TEXT_DEFAULTS = {
  "DOTORE_PASS.BANNER.TITLE": "Dotore Pass",
  "DOTORE_PASS.BANNER.DESCRIPTION":
    "Enroll in every eligible course at no extra cost while your pass is valid.",
  "DOTORE_PASS.BANNER.VALIDITY_DAYS": "{{days}}-day pass",
  "DOTORE_PASS.BANNER.BUY_CTA": "Buy pass",
  "DOTORE_PASS.BANNER.LOGIN_TO_BUY": "Log in to buy",
  "DOTORE_PASS.BANNER.IN_USE": "In use",
  "DOTORE_PASS.BANNER.EXPIRES_ON": "Valid until {{date}}",
  "DOTORE_PASS.BANNER.PERIOD": "{{start}} ~ {{end}}",
  "DOTORE_PASS.BANNER.DAYS_LEFT": "{{days}} days left",
  "DOTORE_PASS.BANNER.LAST_DAY": "Last day",
  "DOTORE_PASS.BANNER.EXPIRING_SOON": "Expiring soon",
  "DOTORE_PASS.BANNER.NO_PASS_TITLE": "You have no active pass",
  "DOTORE_PASS.BANNER.NO_PASS_DESCRIPTION":
    "Buy a Dotore Pass and take eligible courses for free while it is valid.",
  "DOTORE_PASS.BANNER.FREE_ENROLL_HINT": "Eligible courses enroll at 0 with a pass",
  "DOTORE_PASS.LABEL.COVERED_BY_PASS": "Covered by Pass",
  "DOTORE_PASS.PROMO.BEFORE.TITLE": "[[Unlimited Free Trial]] Pass||for Live Classes",
  "DOTORE_PASS.PROMO.BEFORE.SUBTITLE": "Enjoy DOTORE Korean live classes for free until {{date}}!",
  "DOTORE_PASS.PROMO.BEFORE.CTA": "Get Free Trial",
  "DOTORE_PASS.PROMO.ACTIVE.TITLE": "Your free trial is active until {{date}}",
  "DOTORE_PASS.PROMO.ACTIVE.SUBTITLE":
    "Take the placement test so we can match you to the right class.",
  "DOTORE_PASS.PROMO.ACTIVE.CTA": "Take Level Test",
  "DOTORE_PASS.PROMO.CLOSE": "Close",
  "DOTORE_PASS.PROMO.FREE": "FREE",
  "DOTORE_PASS.PROMO.CLASS": "CLASS",
  "DOTORE_PASS.PROMO.COUNTDOWN.DAYS": "Days",
  "DOTORE_PASS.PROMO.COUNTDOWN.HOURS": "Hours",
  "DOTORE_PASS.PROMO.COUNTDOWN.MIN": "Min",
  "DOTORE_PASS.PROMO.COUNTDOWN.SEC": "Sec",
};

export const usePassText = () => {
  const { t: translate } = useTranslation("common_ns", { useSuspense: false });

  return (key, options) =>
    translate(key, { defaultValue: PASS_TEXT_DEFAULTS[key] ?? key, ...options });
};
